import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FolderCardI } from 'src/app/models/folder';
import { AuthenticateService } from 'src/app/services/authenticate.service';

@Component({
    selector: 'app-folder-card-selector',
    templateUrl: './folder-card-selector.component.html',
    styleUrls: ['./folder-card-selector.component.scss']
})
export class FolderCardSelectorComponent {
    @Input() folder: FolderCardI;
    @Input() selected = false;
    @Input() disabled = false;
    @Output() folderClick = new EventEmitter<void>();

    constructor(private authenticateService: AuthenticateService) {}

    get showSharedBy(): boolean {
        return !!this.folder.owner?.email && this.folder.owner.email !== this.authenticateService.currentUser?.email;
    }

    onClick(): void {
        this.folderClick.emit();
    }
}
